








import Vue from 'vue';

import addADeck from '@/lib/helpers/addDeck';

export default Vue.extend({
    props: ['isTourSkip'],
    data() {
        return {
            redirectOnCreate: true,
        }
    },
    methods: {
        async addDeck() {
            addADeck(this.currentUser.uid, this);
        },
    },
})
